<script setup>
import { ref, computed, watch } from 'vue'
import { useCounter, useIdle, useTimestamp } from '@vueuse/core'

const emit = defineEmits(['idle-trigger'])
const props = defineProps(['title', 'timeout', 'color'])

const { timeout } = props
const { inc, count } = useCounter()
const { idle, lastActive, reset } = useIdle(timeout)

const now = useTimestamp()
const tempLastActive = ref(lastActive.value)
const inactive = computed(() => Math.floor((now.value - lastActive.value) / 1000))
const percent = computed(() => Math.floor(((now.value - tempLastActive.value) / timeout) * 100))

watch(idle, (idleValue) => {
  if (idleValue) {
    inc()
    //console.log(`Triggered ${count.value} times`)
    reset()
    tempLastActive.value = now.value
    emit('idle-trigger', count.value)
  }
})

watch(lastActive, (lastValue) => {
  tempLastActive.value = now.value
})
</script>

<template>
  <div class="idle-timer" :title="title">
    <div class="title">{{ title }}</div>
    <span>
      Timeout {{ timeout / 1000 }}<em>s</em> / Inactive {{ inactive }}<em>s</em> / Trigger {{ percent }}% / Triggered
      {{ count }} times
    </span>
    <div :class="['meter', `${color}`]">
      <span :style="{ width: `${percent}%` }"></span>
    </div>
  </div>
</template>

<style scoped>
.container {
  position: relative;
}

.idle-timer {
  color: var(--color-black);
  background-color: #fff;
  width: 500px;
  padding: 10px;
  font-size: 12px;
}

.title {
  font-size: 14px;
  font-weight: bold;
}

.meter {
  height: 20px;
  position: relative;
  background: #ccc;
  border-radius: 25px;
  padding: 5px;
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
}

.meter > span {
  display: block;
  height: 10px;
  width: auto;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: rgb(43, 194, 83);
  background-image: linear-gradient(center bottom, rgb(43, 194, 83) 37%, rgb(84, 240, 84) 69%);
  position: relative;
  overflow: hidden;
}

.orange > span {
  background-color: #f1a165;
  background-image: linear-gradient(to bottom, #f1a165, #f36d0a);
}

.red > span {
  background-color: #f0a3a3;
  background-image: linear-gradient(to bottom, #f0a3a3, #f42323);
}

.blue > span {
  background-color: #f0a3a3;
  background-image: linear-gradient(to bottom, #8fadec, #2365f4);
}

.green > span {
  background-color: #f0a3a3;
  background-image: linear-gradient(to bottom, #45c250, #0da715);
}
</style>
